import { r as t, h as c } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const i = ".sc-calendar-check-icon-h{display:flex}", h = i, s = class {
  constructor(e) {
    t(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return c("svg", { key: "67377dc4802c4f485ba8619ca4662d3092abe08a", width: this.width, height: this.height, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, c("path", { key: "3cb5ec13188746f8efd7e77ea20d76064263fd4c", fill: "currentColor", d: "M14.75 0C16.5449 0 18 1.45507 18 3.25V9.02182C17.5368 8.72526 17.0335 8.48584 16.5 8.3135V5.5H1.5V14.75C1.5 15.7165 2.2835 16.5 3.25 16.5H8.3135C8.48584 17.0335 8.72526 17.5368 9.02182 18H3.25C1.45507 18 0 16.5449 0 14.75V3.25C0 1.45507 1.45507 0 3.25 0H14.75ZM14.75 1.5H3.25C2.2835 1.5 1.5 2.2835 1.5 3.25V4H16.5V3.25C16.5 2.2835 15.7165 1.5 14.75 1.5ZM20 14.5C20 17.5376 17.5376 20 14.5 20C11.4624 20 9 17.5376 9 14.5C9 11.4624 11.4624 9 14.5 9C17.5376 9 20 11.4624 20 14.5ZM17.8536 12.1464C17.6583 11.9512 17.3417 11.9512 17.1464 12.1464L13.5 15.7929L11.8536 14.1464C11.6583 13.9512 11.3417 13.9512 11.1464 14.1464C10.9512 14.3417 10.9512 14.6583 11.1464 14.8536L13.1464 16.8536C13.3417 17.0488 13.6583 17.0488 13.8536 16.8536L17.8536 12.8536C18.0488 12.6583 18.0488 12.3417 17.8536 12.1464Z" }));
  }
};
s.style = h;
const r = ".sc-checkmark-circle-icon-h{display:flex}", a = r, n = class {
  constructor(e) {
    t(this, e), this.width = "20", this.height = "20";
  }
  render() {
    return c("svg", { key: "e47d53cd5c9773d6aa035cdf048de9b73d85b9d3", xmlns: "http://www.w3.org/2000/svg", width: this.width, height: this.height, fill: "none", viewBox: "0 0 20 20" }, c("path", { key: "6b1f48a79cf4172f447d49189071e0110d60c834", fill: "currentColor", d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm3.358 4.646a.5.5 0 0 1 .058.638l-.058.07-4.004 4.004a.5.5 0 0 1-.638.058l-.07-.058-2-2a.5.5 0 0 1 .638-.765l.07.058L9 11.298l3.651-3.652a.5.5 0 0 1 .707 0Z" }));
  }
};
n.style = a;
export {
  s as calendar_check_icon,
  n as checkmark_circle_icon
};
